import React from 'react'

import cn from '../../libs/class-names'

import warningIcon from '../../assets/icons/warning.svg'

import Icon from '../icon'
import {Props as IconProps} from '../icon/icon'

export interface Props {
  classNames?: string[]
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'strong'
  label: React.ReactNode
  addendum?: React.ReactNode
  icon?: IconProps['source']
  size?: 'default' | 's' | 'l' | 'xl'
  warning?: boolean
  minor?: boolean
  invert?: boolean
  inline?: boolean
}

const Headline = ({
  classNames,
  tag = 'h1',
  label,
  addendum,
  icon,
  size = 'default',
  warning = false,
  minor = false,
  invert = false,
  inline = false,
}: Props) => {
  const finalIcon = warning ? warningIcon : icon

  return React.createElement(
    tag,
    {
      className: cn(
        'Headline',
        {warning, minor, invert, inline, [size]: true, addendum: !!addendum},
        classNames
      ),
    },
    <>
      {finalIcon && <Icon key="icon" source={finalIcon} />}
      <div className="Headline__label">{label}</div>
      {addendum && <div className="Headline__addendum">{addendum}</div>}
    </>
  )
}

export default Headline
